if($('.filter-section').length){
    mhFilter();
    document.addEventListener('ShoptetDOMContentLoaded', function() {
        mhFilter();
    }); 
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        mhFilter();
    }); 
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        mhFilter();
    }); 
    
}

function mhFilter(){
    $('html').on('click', '#filters .filter-section:not(.closeFilter) h4', function(){
        $(this).closest('.filter-section').toggleClass('closeIt')
    })
    $('html').on('click', '#filters .filter-section.closeFilter h4', function(){
        $(this).closest('.filter-section').removeClass('closeFilter')
    })
    $('.slider-wrapper').addClass('filter-section')
    $(openFilters).addClass('closeFilter');
    $(specialfilter).addClass('specialFilters');
}